<template>
  <span class="flex text-icon-default cursor-grab active:cursor-grabbing">
    <em
      class="custom-icons"
      :style="[getCustomIconStyle(iconPath('drag'))]"
    />
  </span>
</template>

<script>
import useCustomIcon from '@/utilities/composables/useCustomIcon';

export default {
  name: 'DragHandle',
  setup() {
    const { getCustomIconStyle, iconPath } = useCustomIcon();

    return {
      getCustomIconStyle,
      iconPath,
    };
  },
};
</script>
